import { render } from "./BFormCheckbox.vue?vue&type=template&id=fa28959a&scoped=true&ts=true"
import script from "./BFormCheckbox.vue?vue&type=script&lang=ts"
export * from "./BFormCheckbox.vue?vue&type=script&lang=ts"

import "./BFormCheckbox.vue?vue&type=style&index=0&id=fa28959a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa28959a"]])

export default __exports__